import { getQuery } from 'client/utils/location';
import { DEFAULT_INITIAL_ACTIVE_TAB_ID } from 'site-modules/shared/components/appraisal/appraisal-tabs-container/appraisal-tab-constants';
import { getActiveTabId } from './get-active-tab-id';
import { initializeTabConfiguration } from './tab-initialization';

/**
 * Computes the initial active tab ID based on URL query params and page configuration.
 * Intended for use in page definition preloads to set the critical CSS initialTabId key.
 *
 * @param {Object} options - Configuration options
 * @param {Object} options.location - The location object from page context
 * @param {boolean} options.isLicensePlateTabDefault - Whether license plate tab is configured as default
 * @param {boolean} options.isSellCar - Whether this is a sell car page
 * @param {string} options.referer - The HTTP referer URL from page context
 * @returns {string} The ID of the tab that should be initially active
 */
export const getInitialTabIdFromLocation = ({ location, isLicensePlateTabDefault, isSellCar, referer }) => {
  const { vin, make, model, year, tab } = getQuery(location);
  const { isLicensePlateTabDefaulted } = initializeTabConfiguration({
    tab,
    isLicensePlateTabDefault,
    isSellCar,
    referer,
  });
  return getActiveTabId({
    hasVinQuery: !!vin,
    hasMMYQuery: !!(make && model && year),
    isLicensePlateTabDefault: isLicensePlateTabDefaulted,
    isLookUpStyleView: false,
    initialActiveTabId: DEFAULT_INITIAL_ACTIVE_TAB_ID,
  });
};
